module.exports = "https://trybtryb-legacy.web.app/img/furple.30dddfe0.webp";